/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function WetaFXLogo(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 154 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18442_162884)">
        <g clipPath="url(#clip1_18442_162884)">
          <path
            d="M106.296 20.3896C105.992 18.1702 103.966 14.5716 93.6979 14.3601C86.1066 14.2036 81.6532 15.8001 79.6366 18.3006V14.3369H76.1684V9.07227H66.9429V14.3369H64.0629V19.5233C62.1738 16.7794 58.5143 14.3485 51.4272 14.2876C47.2462 14.2529 44.2039 14.899 41.9931 15.9421L42.6335 14.3137H33.4921L30.1281 24.3997L25.7762 14.3137H16.9709L12.6537 24.42L9.28399 14.3137H0.142578L8.53355 35.6504H16.6464L21.3866 23.1625L26.1297 35.6504H34.2425L36.6821 29.447C38.1193 32.811 42.4162 36.3719 51.1374 36.2676C60.6005 36.1546 65.2364 32.0808 66.0824 28.2214H56.6889C55.7357 30.1598 53.5452 31.2753 51.3576 31.2811C48.4515 31.2898 46.2031 29.899 45.7163 26.8944H66.0795V26.6945H66.0766C66.0737 25.692 66.0129 23.5739 65.0683 21.3661H66.9371C66.9371 21.3661 66.914 30.5104 66.914 30.5712C66.7517 35.5143 69.6086 35.5751 70.9704 35.5664C71.1326 35.5635 81.3867 35.5664 81.3867 35.5664C81.3867 35.5664 81.3867 35.0536 81.3867 34.4422C83.4033 35.4302 85.9211 35.888 88.1029 35.8706C92.7533 35.833 94.4657 34.703 97.2414 33.1731C97.2443 34.0337 97.2443 34.5871 97.2443 34.9406V35.5809H106.403V35.5519H106.415C106.423 27.81 106.487 21.7833 106.296 20.3896ZM45.7279 22.6931C46.6348 20.1752 48.9701 19.2857 51.3663 19.2799C53.5713 19.277 55.8487 20.407 56.5325 22.6931H45.7279ZM77.6982 29.3949C77.6982 29.4296 77.6982 29.4644 77.6982 29.4992C76.6001 29.1978 76.1916 28.6386 76.1945 27.0537L76.1713 21.3603H79.6395V21.3487C84.1305 21.3545 87.5118 21.3806 87.5118 21.3806C87.5118 21.3806 87.9349 19.5639 92.3969 19.5842C97.2849 19.6102 97.1545 21.5341 97.1835 22.1832C92.0753 22.1513 88.5259 22.2469 84.5912 22.9249C80.6565 23.6087 77.7446 25.1588 77.6982 29.3949ZM90.9047 30.4119C86.1153 30.5654 86.0486 27.1175 89.795 26.4221C91.3451 26.1324 93.5704 25.8977 97.1893 25.9875C97.1893 26.6394 95.7927 30.2583 90.9047 30.4119Z"
            fill="black"
          />
          <path
            d="M113.294 17.0227V23.8143H128.589V26.3089H113.294V35.6242H110.318V14.4092H129.189V17.0227L113.294 17.0227Z"
            fill="black"
          />
          <path
            d="M150.163 35.6242L141.448 26.3379L132.793 35.6242H128.676L139.524 24.385L129.997 14.4092H134.143L141.477 22.4322L148.9 14.4092H153.017L143.311 24.3561L154.399 35.6242H150.163Z"
            fill="black"
          />
          <path
            d="M61.9018 11.5266H40.3564V9H61.9279L61.9018 11.5266Z"
            fill="black"
          />
          <path
            d="M102.921 11.5266H81.3755V9H102.947L102.921 11.5266Z"
            fill="black"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18442_162884">
          <rect width="154" height="46" fill="white" />
        </clipPath>
        <clipPath id="clip1_18442_162884">
          <rect
            width="154.257"
            height="27.27"
            fill="white"
            transform="translate(0.142578 9)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

WetaFXLogo.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default WetaFXLogo
